import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/alert-box-red.svg'
import _imports_1 from '@/assets/icons/map.svg'
import _imports_2 from '../../../assets/icons/green-star-circle.svg'
import _imports_3 from '@/assets/icons/id-check.svg'


const _withScopeId = n => (_pushScopeId("data-v-76593a06"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-flex tw-border tw-border-[#fa4b0080] tw-mb-5 tw-p-3 tw-rounded-xl tw-border-solid tw-gap-2 tw-items-center tw-bg-[#fa4b001a] tw-text-[#FA4B00] tw-capitalize tw-text-xs"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "tw-flex tw-border tw-border-[#fa4b0080] tw-mb-5 tw-p-3 tw-rounded-xl tw-border-solid tw-gap-2 tw-items-center tw-bg-[#fa4b001a] tw-text-[#FA4B00] tw-font- tw-capitalize tw-text-xs"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = {
  key: 2,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full"
}
const _hoisted_6 = {
  key: 3,
  class: "tw-flex tw-flex-col tw-items-center tw-justify-center"
}
const _hoisted_7 = { class: "tw-w-full" }
const _hoisted_8 = {
  key: 0,
  class: "tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center rmd:tw-flex-row rmd:tw-justify-between tw-max-w-full md:tw-gap-5"
}
const _hoisted_9 = { class: "left__block tw-flex tw-flex-col tw-gap-6 md:tw-w-full" }
const _hoisted_10 = { class: "tw-flex tw-items-center tw-gap-5 tw-relative md:tw-w-full md:tw-max-w-full md:tw-gap-3 sm:tw-w-[auto]" }
const _hoisted_11 = {
  key: 1,
  class: "tw-rounded-lg tw-max-h-[48px] tw-max-w-[48px] tw-min-h-[48px] tw-min-w-[48px] tw-h-[48px] tw-relative"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "tw-flex tw-flex-col tw-items-start tw-max-w-full" }
const _hoisted_14 = { class: "tw-text-[22px] tw-text-[#0C0F4A] tw-font-medium tw-leading-8 tw-text md:tw-text-lg" }
const _hoisted_15 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-0 rmd:tw-gap-1 tw-flex-row-reverse sm:tw-flex-wrap sm:tw-flex-col-reverse sm:tw-items-start"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_17 = { class: "view-rating-box md:!tw-gap-[4px] !tw-justify-between md:!tw-max-w-[unset] md:!tw-w-full md:!tw-p-[.5rem]" }
const _hoisted_18 = { class: "tw-flex tw-items-center tw-gap-[8px] md:!tw-gap-[4px]" }
const _hoisted_19 = { class: "md:!tw-text-[12px]" }
const _hoisted_20 = { class: "tw-flex tw-flex-col tw-justify-between tw-items-end tw-relative md:tw-w-full md:tw-max-w-full tw-min-h-[180px] md:tw-min-h-[auto] md:tw-gap-4" }
const _hoisted_21 = {
  key: 1,
  class: "tw-flex tw-items-end tw-gap-1 tw-flex-col md:tw-flex-row md:tw-justify-between tw-w-full tw-max-w-full"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "free_workstation_box tw-flex tw-items-center tw-gap-1 tw-px-4 tw-py-1 tw-rounded-lg" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs tw-font-bold tw-leading-6 tw-text-[#24BD63] tw-tracking-wide tw-whitespace-nowrap" }, "FREE WORKSTATION")
], -1))
const _hoisted_23 = {
  key: 1,
  class: "workstation-dashboard tw-flex tw-flex-col tw-gap-6 tw-w-full tw-h-full"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-relative" }, null, -1))
const _hoisted_25 = { class: "tw-w-full tw-h-full tw-grid tw-grid-cols-1 tw-gap-6 tw-box-border rlg:tw-grid-cols-2" }
const _hoisted_26 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-6 tw-min-h-[340px]" }
const _hoisted_27 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-6 tw-min-h-full" }
const _hoisted_28 = { class: "tw-w-full tw-h-full tw-grid tw-grid-cols-1 tw-gap-6 tw-box-border rlg:tw-grid-cols-2" }
const _hoisted_29 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-6" }
const _hoisted_30 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-6" }
const _hoisted_31 = {
  key: 2,
  class: "tw-grid rlg:tw-grid-cols-2 tw-gap-4 rlg:!tw-gap-6 tw-max-w-[1332px] rlg:tw-mt-4"
}
const _hoisted_32 = { class: "tw-w-full tw-flex tw-flex-col tw-justify-between tw-h-full" }
const _hoisted_33 = { class: "custom-card tw-box-border with-border !tw-rounded-[16px] manage-ws-card !tw-max-h-[unset] tw-w-full tw-flex tw-items-center tw-gap-6 lg:!tw-flex-col" }
const _hoisted_34 = { class: "tw-w-full tw-flex tw-flex-col tw-justify-between tw-h-full" }
const _hoisted_35 = { class: "tw-w-full tw-flex tw-items-center tw-gap-6 lg:!tw-flex-col" }
const _hoisted_36 = { class: "tw-flex tw-items-start tw-flex-col tw-gap-6 lg:!tw-w-full" }
const _hoisted_37 = { class: "tw-flex tw-items-center tw-gap-6 lg:!tw-flex-col lg:!tw-w-full lg:!tw-items-start" }
const _hoisted_38 = { class: "tw-min-w-[292px] tw-w-full sign-up-empty-state-banner tw-px-6 tw-py-4 tw-box-border tw-flex tw-flex-col tw-items-start tw-gap-2 tw-bg-[rgba(197,210,242,0.24)] tw-rounded-lg" }
const _hoisted_39 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = ["src"]
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "tw-w-full tw-flex-col tw-bg-white tw-border-solid-default tw-px-8 tw-box-border tw-py-6 tw-flex tw-items-start tw-gap-6 tw-rounded-[16px] rxl:!tw-flex-row" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "tw-flex tw-flex-col tw-gap-4 tw-items-start" }
const _hoisted_46 = { class: "tw-w-full tw-flex tw-flex-col tw-justify-between tw-h-full" }
const _hoisted_47 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between tw-pb-4 tw-box-border" }
const _hoisted_48 = { class: "tw-flex tw-items-center tw-gap-4 md:!tw-flex-col md:!tw-items-start md:!tw-gap-[.5rem] md:!tw-w-full" }
const _hoisted_49 = {
  key: 0,
  class: "tw-w-full tw-flex tw-flex-col tw-gap-4 tw-pt-5 tw-box-border tw-overflow-auto no-scrollbar"
}
const _hoisted_50 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-gap-4 tw-border-b tw-border-0 tw-border-dashed tw-border-[#C5D2F2] tw-pb-5"
}
const _hoisted_51 = { class: "tw-flex tw-items-center tw-w-full tw-justify-between md:tw-border-0 md:tw-pb-3 md:tw-border-b md:tw-border-dashed md:tw-border-[#8687A5] s430:tw-gap-2" }
const _hoisted_52 = { class: "chip-state tw-px-[.5rem] tw-py-[.2rem] tw-text-[14px] tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F98228]/[0.26] tw-text-[#0C0F4A] tw-font-medium tw-capitalize" }
const _hoisted_53 = { class: "tw-w-full tw-flex tw-items-center md:tw-items-start tw-gap-2 rmd:!tw-items-start tw-mt-3" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "tw-w-full tw-flex md:tw-flex-col md:tw-items-start tw-justify-between tw-items-center tw-gap-2 tw-flex-wrap" }
const _hoisted_56 = { class: "tw-flex tw-flex-col tw-item-start" }
const _hoisted_57 = { class: "tw-flex tw-items-center md:tw-flex-col-reverse md:tw-items-start tw-gap-2 tw-flex-wrap" }
const _hoisted_58 = { class: "chip-state tw-px-[.5rem] tw-py-[.2rem] tw-text-[14px] tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F98228]/[0.26] tw-text-[#0C0F4A] tw-font-medium tw-capitalize" }
const _hoisted_59 = { class: "tw-flex tw-flex-wrap tw-gap-2 tw-mt-2" }
const _hoisted_60 = { class: "tw-px-[.5rem] tw-py-[.2rem] tw-box-border tw-text-[14px] tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#0c0f4a1a] tw-text-[#0C0F4A] tw-font-medium tw-capitalize" }
const _hoisted_61 = { class: "tw-flex tw-items-start tw-flex-col" }
const _hoisted_62 = { class: "tw-flex tw-items-start tw-flex-col tw-gap-2" }
const _hoisted_63 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2 tw-flex-wrap"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-ml-[3px]" }, "Reject", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-ml-[3px]" }, "Accept", -1))
const _hoisted_66 = {
  key: 1,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_67 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_68 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3 tw-justify-between" }
const _hoisted_69 = { class: "tw-flex tw-items-center tw-w-full tw-justify-between md:tw-border-0 md:tw-pb-3 md:tw-border-b md:tw-border-dashed md:tw-border-[#8687A5] s430:tw-gap-2" }
const _hoisted_70 = { class: "chip-state tw-px-[.5rem] tw-py-[.2rem] tw-text-[14px] tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F98228]/[0.26] tw-text-[#0C0F4A] tw-font-medium tw-capitalize" }
const _hoisted_71 = { class: "md:tw-flex tw-items-center tw-gap-2 tw-flex-wrap tw-relative tw-hidden" }
const _hoisted_72 = { class: "notification__count tw-absolute tw-top-0 tw-left-8 tw-w-[15px] tw-h-[15px] tw-bg-red-400 tw-text-white tw-rounded-full tw-text-center tw-text-xs" }
const _hoisted_73 = { class: "tw-w-full tw-flex tw-items-center md:tw-items-start tw-gap-2 rmd:!tw-items-start tw-mt-3" }
const _hoisted_74 = ["src"]
const _hoisted_75 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-2 tw-flex-wrap tw-w-[calc(100%_-_64px)] md:!tw-flex-col md:!tw-items-start" }
const _hoisted_76 = { class: "tw-flex tw-flex-col tw-item-start tw-gap-[2px]" }
const _hoisted_77 = { class: "tw-flex tw-items-center md:tw-flex-col-reverse md:tw-items-start tw-gap-2 tw-flex-wrap" }
const _hoisted_78 = {
  key: 0,
  class: "chip-state tw-px-[.5rem] tw-text-[14px] tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F98228]/[0.26] tw-text-[#0C0F4A] tw-font-medium tw-capitalize !tw-py-0"
}
const _hoisted_79 = {
  key: 1,
  class: "chip-state tw-px-[.5rem] tw-text-[14px] tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F98228]/[0.26] tw-text-[#0C0F4A] tw-font-medium tw-capitalize !tw-py-0"
}
const _hoisted_80 = {
  key: 0,
  class: "tw-flex tw-gap-2 tw-flex-wrap tw-mt-1"
}
const _hoisted_81 = { class: "tw-px-[.5rem] tw-py-[.2rem] tw-box-border tw-text-[14px] tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#0c0f4a1a] tw-text-[#0C0F4A] tw-font-medium tw-capitalize" }
const _hoisted_82 = { class: "tw-h-full tw-flex tw-items-start tw-flex-col tw-justify-between tw-gap-[3px]" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center" }, null, -1))
const _hoisted_84 = { class: "tw-flex tw-items-center tw-gap-2 tw-flex-wrap tw-relative md:tw-hidden" }
const _hoisted_85 = { class: "notification__count tw-absolute tw-top-0 tw-left-8 tw-w-[15px] tw-h-[15px] tw-bg-red-400 tw-text-white tw-rounded-full tw-text-center tw-text-xs" }
const _hoisted_86 = { class: "md:tw-mt-3 md:tw-block tw-hidden tw-ml-auto" }
const _hoisted_87 = { class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-pt-5 tw-border-t-solid-custom s540:!tw-flex-col s540:!tw-items-start" }
const _hoisted_88 = {
  key: 0,
  class: "tw-flex tw-items-center"
}
const _hoisted_89 = {
  key: 1,
  class: "custom-card tw-box-border with-border !tw-rounded-[16px] manage-ws-card !tw-max-h-[unset] tw-w-full tw-flex tw-items-center tw-gap-6 lg:!tw-flex-col"
}
const _hoisted_90 = { class: "tw-flex tw-items-start tw-flex-col tw-gap-6 lg:!tw-w-full" }
const _hoisted_91 = { class: "tw-flex tw-items-center tw-gap-6 lg:!tw-flex-col lg:!tw-w-full lg:!tw-items-start" }
const _hoisted_92 = { class: "tw-min-w-[292px] tw-w-full sign-up-empty-state-banner tw-px-6 tw-py-4 tw-box-border tw-flex tw-flex-col tw-items-start tw-gap-2 tw-bg-[rgba(197,210,242,0.24)] tw-rounded-lg" }
const _hoisted_93 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_95 = ["src"]
const _hoisted_96 = ["src"]
const _hoisted_97 = { class: "tw-w-full tw-flex-col tw-bg-white tw-border-solid-default tw-px-8 tw-box-border tw-py-6 tw-flex tw-items-start tw-gap-6 tw-rounded-[16px] rxl:!tw-flex-row" }
const _hoisted_98 = ["src"]
const _hoisted_99 = { class: "tw-flex tw-flex-col tw-gap-4 tw-items-start" }
const _hoisted_100 = { class: "tw-flex tw-flex-col tw-items-start tw-justify-between" }
const _hoisted_101 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-6 tw-pb-4" }
const _hoisted_102 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-4" }
const _hoisted_103 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-4" }
const _hoisted_104 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-border-0 tw-pb-2" }
const _hoisted_105 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_106 = { class: "tw-w-auto tw-px-2 tw-box-border tw-rounded-[4px] tw-bg-[rgba(79,85,240,0.1)] tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-[#4F55F0]" }
const _hoisted_107 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_108 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_109 = { class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-pt-5 tw-border-t-solid-custom" }
const _hoisted_110 = { class: "tw-flex tw-items-center tw-gap-8 md:!tw-gap-6 md:!tw-flex-col md:tw-items-start" }
const _hoisted_111 = ["src"]
const _hoisted_112 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between" }
const _hoisted_113 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-6 tw-pb-2" }
const _hoisted_114 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-4" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-flex-col tw-items-start tw-gap-4" }, null, -1))
const _hoisted_116 = { class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-pt-5 tw-border-t-solid-custom" }
const _hoisted_117 = { class: "tw-flex tw-items-start tw-gap-8 md:!tw-gap-6 md:!tw-flex-col" }
const _hoisted_118 = ["src"]
const _hoisted_119 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between" }
const _hoisted_120 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-6" }
const _hoisted_121 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-4" }
const _hoisted_122 = { class: "modal_wrapper" }
const _hoisted_123 = { class: "main" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-dots" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "dot dot-red" }),
  /*#__PURE__*/_createElementVNode("span", { class: "dot dot-blue" }),
  /*#__PURE__*/_createElementVNode("span", { class: "dot dot-green" })
], -1))
const _hoisted_125 = { class: "switching-text" }
const _hoisted_126 = { class: "modal_content" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Hello We will require your passport or driver’s license."),
  /*#__PURE__*/_createElementVNode("p", null, " Verified ID is required to ensure trust security and compliance on Iknowa. ")
], -1))
const _hoisted_128 = { class: "content" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "your-img-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "open-logo",
    src: _imports_3
  })
], -1))

import { computed, onBeforeMount, ref, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import { WORKSTATION } from "@/store/modules/workstation";
// import SpeedMeterComponent from "@/modules/dashboard/components/SpeedMeterComponent.vue";
import PropertyOwnerBenefitsModal from "@/modules/dashboard/components/PropertyOwnerBenefitsModal.vue";
import { VUE_APP_PROPERTY_DATA_API } from "@/config";
import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import WorkStationProfileLogo from "@/core/components/WorkStationProfileLogo.vue";
// import KnowYourPropertyComponentModal from "@/modules/dashboard/components/KnowYourPropertyComponent.vue";
import {
  getCombineSameProjectReview,
  getLocalStorageWithExpiry,
  isAliased,
  parseJSON,
  setLocalStorageWithExpiry,
} from "@/core/utils/common";
import { RolesEnum, UserRolesEnum } from "@/core/enums/RolesEnum";
import { PROJECT_STORE } from "@/store/modules/project";
import {
  BusinessDetailTypeEnum,
  UserVerificationStatusEnum,
  MemberInvitationStatusEnum,
} from "@/core/enums/RolesEnum";
import Text from "@/core/components/ui/general/Text.vue";
import Card from "@/core/components/ui/general/Card.vue";
import Button from "@/core/components/ui/general/Button.vue";
import ProfileThumbnail from "@/core/uni-components/ProfileThumbnail.vue";
import Postcode from "@/core/uni-components/Chips/Postcode.vue";
import { getImageApiUrl, getImageStringToImageURL } from "@/core/utils/common";
import $axios from "@/core/utils/axios-api-config";
import { MEMBER_STORE } from "@/store/modules/manage-member";
import WorkstationVerificationModal from "@/modules/workstation/components/WorkstationVerificationModal.vue";
import PropertyOwnerWorkStationModal from "@/modules/workstation/propertyowner/pages/PropertyOwnerWorkStationModal.vue";
import WorkStationVerificationLock from "@/core/components/WorkStationVerificationLock.vue";
import PropertyOwnerSubscriptionModal from "@/modules/workstation/propertyowner/pages/PropertyOwnerSubscriptionModal.vue";

// WIDGETS
import PreferredContractorsWidget from "@/modules/dashboard/components/Widgets/PreferredContractorsWidget.vue";
import PropertiesWidget from "@/modules/dashboard/components/Widgets/PropertiesWidget.vue";
import ProjectsOverviewWidget from "@/modules/dashboard/components/Widgets/ProjectsOverviewWidget.vue";
import TeamWidget from "@/modules/dashboard/components/Widgets/TeamWidget.vue";
import CalendarEventWidget from "@/modules/dashboard/components/Widgets/CalendarEventWidget.vue";
import AddEmailActionChip from "./Chips/AddEmailActionChip.vue";
import AddEmailModal from "@/modules/dashboard/components/Modals/AddEmailModal.vue";
import ApproveChip from "@/modules/dashboard/components/Chips/ApproveChip.vue";
import DeleteActionChip from "@/modules/dashboard/components/Chips/DeleteActionChip.vue";
import PendingChip from "@/modules/dashboard/components/Chips/PendingChip.vue";
import EmailConformModal from "./Modals/EmailConformModal.vue";
import manageEmailService from "@/core/services/manage-email.service";
import { PROPERTY_STORE } from "@/store/modules/property";
import UpgradePremiumWorkstationModal from "@/modules/workstation/propertyowner/pages/UpgradePremiumWorkstationModal.vue";
import { DASHBOARD_ROUTE } from "@/modules/dashboard/routes";
import MyWorkstationChip from "./Chips/MyWorkstationChip.vue";
import LunchIcon from "@/core/components/icons/LunchIcon.vue";
import TrashIcon from "@/core/components/icons/TrashIcon.vue";
import Loader from "@/core/components/common/Loader.vue";
import AddAddressModal from "@/modules/dashboard/components/Modals/AddAddressModal.vue";
import { PREFERRED_CONTRACTORS } from "@/store/modules/preferred-contractors";
import { VIEW_RATING_ROUTE } from "@/modules/view-rating/routes";
import { REVIEW_RATING_STORE } from "@/store/modules/review-rating";
import { ProjectRatingTypeEnum } from "@/core/enums/ProjectsEnum";
import {
  CreateProjectRatingPayloadWithId,
  reviewRatingState,
} from "@/core/models/project-rating";
import { UserWorkstationVerificationType } from "@/core/enums/RolesEnum";
import ProfileVerificationStatusChip from "./Chips/ProfileVerificationStatusChip.vue";
import PropertyServicePlanModal from "@/modules/dashboard/components/Modals/PropertyServicePlanModal.vue";
import InputSelect from "@/core/components/common/InputSelect.vue";
import TradePersonBenefitsModal from "@/modules/dashboard/components/TradePersonBenefitsModal.vue";
import pdfFile from "@/assets/pdf/iknowa Heat Pump Service Plan (EXAMPLE ONLY).pdf";
import { UserWorkstationSubStatusEnum } from "@/core/enums";
import { ADD_PROPERTY_ROUTE } from "@/modules/properties/routes";
import { PROPERTY_TYPE } from "@/modules/properties/constants";
import { AUTH_SESSION_EXPIRY, AUTH_USER } from "@/core/constants";
import userService from "@/core/services/user.service";
import NotificationIcon from "@/core/components/icons/NotificationIcon.vue";
import CommonDialog from "@/core/components/CommonDialog.vue";
import ChipState from "@/core/components/common/ChipState.vue";
import CheckGreenShield from "@/core/components/icons/CheckGreenShield.vue";
import InfoIconRed from "@/core/components/icons/InfoIconRed.vue";
import PropertySuccessModal from "@/core/components/common/PropertySuccessModal.vue";
import ClientFlowServiceAgreementModal from "@/modules/clients/components/model/ClientFlowServiceAgreementModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyOwnerDashboard',
  setup(__props) {

const store = useStore();
const router = useRouter();
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const progressValue = ref("50%");
const propertyListData = ref([]) as any;
const loading = ref(false);
const isWorkstationEmpty = ref(false);
const WorkStationInvitation = ref();
const InviteMemberImage = ref();
const modelName = {
  VERIFYMODAL: "verifyModal",
  ADDRESSMODAL: "addressModal",
};

const teamMemberLoading = ref(false);
const members = ref([]) as any;
const isLoading = ref(false) as any;

const openedModel = ref("");
const isShowUpgradePremiumModal = ref(false);
const isShowPropertyOwnerWorkStationModal = ref(false);
const isShowPropertyOwnerSubscriptionModal = ref(false);
const isShowknowpropertyModal = ref(false);
const userImage = computed(() => store.getters[`${USER_STORE}/userImage`]);
const userFullName = computed(() => {
  return `${user.value?.firstName} ${user.value?.lastName}`;
});
const isShowAddEmailModal = ref(false);
const isShowAddEmailConformModal = ref(false);
const manageEmailList: any = ref([]);
const emailConfirmModalType = ref("");
const manageEmail = ref() as any;
const statusModal = { PAYMENT: "payment", KYC: "kyc" };
const currentStatusModalName = ref("");
const currentModalStatus = ref("");
const isShowPropertyOwnerBenefitsModal = ref(false);
const launchInvitedWorkstation = ref(false);
const isShowIDCheckModal = ref(false);
const HeaderTittle = ref("");
const isShowNextButton = ref(false);
const isShowSuccessModel = ref(false);
const isShowClientAgreementModal = ref(false);
const tabListItems = [
  {
    tab: "step1",
    name: "Switching Account...",
  },
  {
    tab: "step2",
    name: "Fetching Account Data...",
  },
  {
    tab: "step3",
    name: "Loading Account...",
  },
];

const toolTipProfile = computed(() => {
  if (userWorkStationStatus.value == 2)
    return ` <h3 style='margin: 0; color: #40ae42;'>
              KYC Verified
          </h3>
            <p style='margin: 5px 0 0;'> Your identity has been successfully verified! Your account is now fully secure and ready to access all features. Thank you for completing the verification process. </p>
            `;
  else
    return `<h3 style='margin: 0; color: #faa500;'>
            KYC Pending
          </h3>
          <p style='margin: 5px 0 0;'>
            Your identity verification is pending. This step ensures the security of your account, protecting it from fraud and unauthorized access.
          </p>`;
});

const switchingText = ref("Switching Account...");
const currentSelectedTab = ref(tabListItems[0]);
onUnmounted(() => {
  store.commit(`${WORKSTATION}/setPropertyOwnerWorkStationModelState`, false);
});

const userAllWorkStation = computed(
  () => store.getters[`${WORKSTATION}/getUserWorkstations`]
);
const userNotifications = computed(
  () => store.getters[`${USER_STORE}/userNotifications`]
);
const filteredUserAllWorkStation = computed(() =>
  userAllWorkStation.value.filter(
    (workstation: any) => workstation.name !== "Default"
  )
);

const WorkStationSiltVerificationStatus = computed(
  () => store.getters[`${WORKSTATION}/getWorkStationSiltVerificationStatus`]
);
const isshowKycModel = computed(
  () => store.getters[`${WORKSTATION}/isshowKycModel`]
);

const isWorkstationLoading = computed(
  () => store.getters[`${WORKSTATION}/loadingWorkstation`]
);

const onClickToggleTradesWorkStation = () => {
  // isShowPropertyOwnerWorkStationModal.value = true;
  router.push({
    path: `create-workstation/property-owner`,
  });
  // store.commit(
  //   `${WORKSTATION}/setPropertyOwnerWorkStationModelState`,
  //   !isShowCreatePropertyOwnerWorkStationModal.value
  // );
};

const isShowCreatePropertyOwnerWorkStationModal = computed(
  () => store.getters[`${WORKSTATION}/getPropertyOwnerWorkStationModelState`]
);
const onClickCloseWelcomeModal = () => {
  isShowknowpropertyModal.value = false;
  localStorage.setItem("isShowknowpropertyPopup", JSON.stringify(true));
};
const route = useRoute();
const redirectEscrowPayment = () => {
  if (
    user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER &&
    route.query.result &&
    route.query.paymentInitiationId
  ) {
    const data = localStorage.getItem("escrowPayment") as any;
    if (data) {
      const details = parseJSON(data);
      store.dispatch(
        `${PROJECT_STORE}/setProjectRedirectTabName`,
        "escrow-account"
      );
      router.push({
        path: `/project-details/${details?.url}`,
        query: {
          result: route.query.result,
          paymentInitiationId: route.query.paymentInitiationId,
        },
      });
      // localStorage.removeItem("escrowPayment");
    }
  }
};

const onClickViewGoogleEvent = () => {
  const link = "https://qc6kd2k4jjk.typeform.com/to/Z37e81Id";
  window.open(link, "_blank");
};

const onClickBenefitsButton = () => {
  isShowPropertyOwnerBenefitsModal.value = true;
};

// const toggleBenefitModal = () => {
//   isShowPropertyOwnerBenefitsModal.value = false;
// };
const toggleBenefitModal = () => {
  isShowPropertyOwnerBenefitsModal.value =
    !isShowPropertyOwnerBenefitsModal.value;
};
const getPreferredContractorsConnection = async () => {
  try {
    let params = {
      status: "accepted",
    };
    await store.dispatch(
      `${PREFERRED_CONTRACTORS}/getPreferredContractorsConnection`,
      {
        userId: user.value?.id,
        params: params,
      }
    );
  } catch (err) {
    console.log();
  }
};
const getAllProjectReviewList = computed<
  reviewRatingState["allProjectReviewList"]
>(() => store.getters[`${REVIEW_RATING_STORE}/getAllProjectReviewList`]);
const combineSameProjectReview = computed(() =>
  getCombineSameProjectReview(getAllProjectReviewList.value)
);
const getAverageOfAllProjectReview = computed(() => {
  const totalAvg = combineSameProjectReview.value.reduce(
    (totalRating: number, review: any) => {
      totalRating += review.totalAvg || 0;
      return totalRating;
    },
    0
  );
  return totalAvg
    ? Math.round((totalAvg * 100) / combineSameProjectReview.value.length) / 100
    : totalAvg;
});

const getCheckoutUserKYC = async () => {
  try {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (!params?.silt_user_id) return;
    const soloTraderVerificationData = await store.dispatch(
      `${WORKSTATION}/getWorkStationSiltVerificationStatus`,
      {
        id: params.silt_user_id,
        verificationType: UserWorkstationVerificationType.KYC,
      }
    );
    console.log(soloTraderVerificationData);
    await store.dispatch(
      `${WORKSTATION}/saveWorkstationVerificationData`,
      soloTraderVerificationData
    );

    let status = UserVerificationStatusEnum.PENDING_VERIFICATION;
    if (soloTraderVerificationData.status === "SUCCESS") {
      status = UserVerificationStatusEnum.VERIFIED;
    }

    const data = {
      userId: user.value?.id,
      userWorkstationId: activeUserWorkstation.value?.id,
      formData: {
        verificationStatus: status,
      },
    };
    await store.dispatch(`${WORKSTATION}/updateUserWorkstationStatus`, data);

    currentStatusModalName.value = statusModal.KYC;
    currentModalStatus.value = soloTraderVerificationData?.status;
    openedModel.value = "";
    await store.dispatch(`${USER_STORE}/initializeUserState`);
  } catch (error: any) {
    if (error?.response?.status === 400) {
      currentStatusModalName.value = statusModal.KYC;
      openedModel.value = "";
      currentModalStatus.value = "ERROR";
      return;
    }
  }
};

const getTeamMember = async () => {
  try {
    teamMemberLoading.value = true;
    const response = await store.dispatch(`${MEMBER_STORE}/getTeamMember`, {
      userId: user.value?.id,
    });

    members.value = await Promise.all(
      response.map(async (member: any) => {
        if (member?.toUserId) {
          if (member?.toUser?.userPublicProfile) {
            member.userProfileImageUrl = await getImageStringToImageURL(
              member?.toUser?.userPublicProfile?.profileImage
            );
          } else {
            member.userProfileImageUrl = null;
          }
        } else {
          member.userProfileImageUrl = null;
        }
        return member;
      })
    );
  } catch (err) {
    console.log();
  } finally {
    console.log("members value", members.value);
    teamMemberLoading.value = false;
  }
};
const onClickCloseIDCheckButton = () => {
  isShowIDCheckModal.value = false;
};
const onClickKycTypeIdVerification = async () => {
  try {
    isLoading.value = true;
    const currentDomain = window.location.origin;
    const payload = {
      callback: `${currentDomain}/dashboard`,
      vendor_data: `${user.value.id}-${activeUserWorkstation.value.id}`,
    };

    const response = await store.dispatch(
      `${WORKSTATION}/sendUserKYCProcessMail`,
      payload
    );

    const redirectUrl = response?.url;
    if (redirectUrl) {
      window.location.href = redirectUrl;
      await store.dispatch(`${WORKSTATION}/setIsShowKycModel`, false);
      isLoading.value = false;
    } else {
      isLoading.value = false;
    }
  } catch (err) {
    isLoading.value = false;
  }
};

const toggleSuccessModel = () => {
  isShowSuccessModel.value = !isShowSuccessModel.value;
  if (!isShowSuccessModel.value) {
    onToggleClientAgreementModal();
  }
};
const onToggleClientAgreementModal = () => {
  isShowClientAgreementModal.value = !isShowClientAgreementModal.value;
};

const checkIsClientRaiseEstimateFlow = () => {
  const isClientRaiseEstimateFlow = localStorage.getItem(
    "isClientRaiseEstimateFlow"
  );
  if (parseJSON(isClientRaiseEstimateFlow)) {
    toggleSuccessModel();
  }
  localStorage.removeItem("isClientRaiseEstimateFlow");
};
onBeforeMount(async () => {
  if (isshowKycModel.value) {
    isShowIDCheckModal.value = true;
  }
  checkIsClientRaiseEstimateFlow();
  redirectEscrowPayment();
  getWorkStationInvitation();
  getCheckoutUserKYC();
  getPreferredContractorsConnection();
  await store.dispatch(
    `${REVIEW_RATING_STORE}/getAllProjectReviewList`,
    ProjectRatingTypeEnum.PROPERTY_OWNER
  );
  await store.dispatch(
    `${WORKSTATION}/getPropertyOwnerUserWorkstations`,
    user.value.id
  );
  getTeamMember();
  setManageEmailList();
  isShowknowpropertyModal.value = parseJSON(
    localStorage.getItem("isShowknowpropertyPopup")
  )
    ? false
    : true;
  try {
    loading.value = true;
    // const response = await axios.get(
    //   `https://api.propertydata.co.uk/sourced-properties?key=${VUE_APP_PROPERTY_DATA_API}&list=repossessed-properties&postcode=${user.value?.postcode}`
    // );
    // if (response.status === 200) {
    // propertyListData.value = response.data.properties[0];
    propertyListData.value = {
      id: "R142978070",
      address: "9 Cornwallis Avenue",
      addressLine1: "Folkestone, Kent, UK",
      postcode: "CT19 5JA",
      type: " Leasehold | LH2RYU",
      bedrooms: 3,
      price: 2250000,
      sqf: 1895,
      days_on_market: 47,
      sstc: 0,
      lat: "51.49305000",
      lng: "-0.15286000",
      distance_to: "0.73",
      highest_offer: null,
    };

    await store.dispatch(`${PROPERTY_STORE}/fetchProperties`, {});

    // }

    // addressListfromPostcode.value = response.data.results;
  } catch (error) {
    console.log("error", error);
  } finally {
    loading.value = false;
  }
});

const onClickSelectWorkstation = () => {
  router.push("/select-workstation");
};
const onClickUpdateProfile = () => {
  router.push("/profile");
};

const userName = computed(() => {
  return `${user.value?.firstName}`;
});

const userEmail = computed(() => {
  return `${user.value?.email}`;
});

const userWorkStationImage = computed(
  () => store.getters[`${USER_STORE}/userWorkStationImage`]
);

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const getWorkstationAddress = (type: string) => {
  if (type === BusinessDetailTypeEnum.LIMITED_COMPANY) {
    return user.value?.userBusinessDetails?.businessAddress;
  }
  return user.value?.userBusinessDetails?.residencyAddressLine;
};

const getWorkstationPostcode = (type: string) => {
  if (type === BusinessDetailTypeEnum.LIMITED_COMPANY) {
    return user.value?.userBusinessDetails?.businessPostcode;
  }
  return `${user.value?.userBusinessDetails?.residencyPostcode},`;
};

const userWorkStationStatus = computed(
  () =>
    store.getters[`${WORKSTATION}/activeUserWorkstation`]?.verificationStatus
);

const userWorkstationStatusByWord = computed(() => {
  if (userWorkStationStatus.value === UserVerificationStatusEnum.NOT_ADDED) {
    return "PO-UNVERIFIED";
  }
  if (userWorkStationStatus.value === UserVerificationStatusEnum.VERIFIED) {
    return "PO-VERIFIED";
  }
  if (
    userWorkStationStatus.value ===
    UserVerificationStatusEnum.PENDING_VERIFICATION
  ) {
    return "PO-PENDING";
  }
  return "";
});

const userBusinessType = computed(() => user.value?.userBusinessDetails?.type);

// NOTE: Must be isUserProfileVerifiable
const isUserProfileVerified = computed(
  () => store.getters[`${USER_STORE}/isUserProfileVerifiable`]
);

const isUserTaxDetailsAdded = computed(
  () =>
    user.value?.userBusinessDetails?.taxReferenceNumber &&
    user.value?.userBusinessDetails?.ukVatNumber
);

const workstationSetupProgress = computed(() => {
  if (
    !isUserWorkstationIsDefault.value &&
    isUserProfileVerified.value &&
    isUserTaxDetailsAdded.value
  ) {
    return 66;
  }
  if (!isUserWorkstationIsDefault.value) {
    return 33;
  }
  return 0;
});

const isUserWorkstationIsDefault = computed(
  () =>
    activeUserWorkstation.value?.name === "Default" &&
    activeUserWorkstation.value?.status === "active"
);

const acceptInvitaionLoader = ref(false);
const acceptInvitationWorkstationId = ref<null | string>(null);
const onClickAcceptWSInvitation = async (token: string) => {
  if (
    user.value?.userKYCVerificationStatus ===
    UserVerificationStatusEnum.VERIFIED
  ) {
    try {
      acceptInvitaionLoader.value = true;
      acceptInvitationWorkstationId.value = token;
      await store.dispatch(`${USER_STORE}/acceptWorkStationInvitation`, {
        userId: user.value?.id,
        key: token,
      });
      getWorkStationInvitation();
      await store.dispatch(
        `${WORKSTATION}/getPropertyOwnerUserWorkstations`,
        user.value.id
      );
    } catch (err) {
      console.log();
    } finally {
      acceptInvitaionLoader.value = false;
      acceptInvitationWorkstationId.value = null;
    }
  } else {
    openedModel.value = "verifyModal";
  }
};

const onClickCloseModel = async () => {
  openedModel.value = "";
  await store.dispatch(`${USER_STORE}/getAccountStatuses`);
};

const deleteInvitedWorkstationLoader = ref(false);
const deleteInvitedWorkstationId = ref<null | number>(null);
const onClickRejectWSInvitation = async (id: number) => {
  try {
    deleteInvitedWorkstationLoader.value = true;
    deleteInvitedWorkstationId.value = id;
    const response = await store.dispatch(
      `${MEMBER_STORE}/deleteMemberDetails`,
      {
        userId: user.value?.id,
        userMemberId: id,
      }
    );
    getWorkStationInvitation();
    await store.dispatch(
      `${WORKSTATION}/getPropertyOwnerUserWorkstations`,
      user.value.id
    );
  } catch (err) {
    console.log();
  } finally {
    deleteInvitedWorkstationLoader.value = false;
    deleteInvitedWorkstationId.value = null;
  }
};

const getWorkStationInvitation = async () => {
  try {
    const response = await store.dispatch(
      `${USER_STORE}/getWorkStationInvitation`,
      user.value?.id
    );
    WorkStationInvitation.value = response;
    const image = getImageApiUrl(
      response[0]?.userWorkstation?.profileImage,
      true
    );
    const encoded: any = await $axios.get(image);
    InviteMemberImage.value = encoded?.publicUrl;
  } catch (err) {
    console.log();
  }
};

const onClickClosePOWorkstationModal = () => {
  isShowPropertyOwnerWorkStationModal.value = false;
};

const freePlan = computed(() => {
  return (
    (userWorkStationStatus.value === UserVerificationStatusEnum.NOT_ADDED &&
      !activeUserWorkstation.value?.subscription) ||
    activeUserWorkstation.value?.subStatus !==
      UserWorkstationSubStatusEnum.SUCCEEDED
  );
});

const properties = computed(
  () => store.getters[`${PROPERTY_STORE}/properties`]
);

const isShowAllws = ref(false);

const numberOfWsShowed = computed(() => {
  if (isShowAllws.value) {
    return filteredUserAllWorkStation.value.length;
  }
  return 3;
});

const toggleShowWs = () => {
  isShowAllws.value = !isShowAllws.value;
};

const onClickAddNewProperty = () => {
  if (freePlan.value && properties.value.length >= 1) {
    onClickUpgradePlan();
  } else {
    router.push({
      name: ADD_PROPERTY_ROUTE,
      params: { type: PROPERTY_TYPE },
    });
  }
};

const onClickVerifyAccount = () => {
  isShowPropertyOwnerSubscriptionModal.value = true;
};

const onClickCloseButton = async () => {
  isShowPropertyOwnerSubscriptionModal.value = false;
  getWorkStationInvitation();
  await store.dispatch(
    `${WORKSTATION}/getPropertyOwnerUserWorkstations`,
    user.value.id
  );
  setManageEmailList();
};
const toggleAddEmailModal = (event: boolean) => {
  isShowAddEmailModal.value = event;
};
const toggleAddEmailConfirmModal = (status = false) => {
  isShowAddEmailConformModal.value = !isShowAddEmailConformModal.value;
  if (status) {
    manageEmailList.value = manageEmailList.value.filter(
      (data: any) => data.id !== manageEmail.value?.id
    );
    manageEmail.value = "";
  }
};

const onClickUpgradePlan = () => {
  isShowUpgradePremiumModal.value = true;
};

const closeUpgradePremiumModal = () => {
  isShowUpgradePremiumModal.value = false;
};

const setManageEmailList = async () => {
  try {
    const response: any = await manageEmailService.getEmailList(user.value?.id);
    manageEmailList.value = response?.aliases;
  } catch (error) {
    console.error("get email list error", error);
  }
};
const onClickDeleteEmail = (data: any) => {
  manageEmail.value = data;
  emailConfirmModalType.value = "delete";
  toggleAddEmailConfirmModal();
};
const onClickAddEmail = (addEmailData: object) => {
  manageEmailList.value.push(addEmailData);
  isShowAddEmailModal.value = false;
  emailConfirmModalType.value = "success";
  toggleAddEmailConfirmModal();
};

const onClickAddress = () => {
  // if (user.value?.address) return;
  openedModel.value = modelName.ADDRESSMODAL;
};

const onWorkStationClick = async (workstationId: number, resetData = true) => {
  try {
    await store.dispatch(`${WORKSTATION}/setLoadingWorkstation`, true);
    if (!workstationId) return;

    const workstation = filteredUserAllWorkStation.value.find(
      (workstation: any) => workstation?.id === workstationId
    );
    if (workstation?.isInvited) {
      await store.dispatch(`${WORKSTATION}/isFirstTimeLaunchWorkStation`, {
        userId: user.value?.id,
        memberId: workstation?.memberId,
      });
    }
    if (workstation?.isInvited && !workstation?.isSameRole) {
      await userService.activateWorkstation(user.value?.id, workstation?.id);
      onClickSwitchUserType();
      return;
    }
    if (resetData) {
      await router.push({ name: DASHBOARD_ROUTE });
      await store.dispatch(`${WORKSTATION}/activateWorkstation`, {
        userId: user.value?.id,
        userWorkstationId: workstationId,
      });
    }
    const workstationVerification = await store.dispatch(
      `${WORKSTATION}/getWorkstationVerificationData`,
      workstationId
    );
    if (
      workstationVerification &&
      workstationVerification?.response?.id &&
      ["KYC", "KYB"].includes(workstationVerification?.verificationType)
    ) {
      await store.dispatch(
        `${WORKSTATION}/getWorkStationSiltVerificationStatus`,
        {
          id: workstationVerification.response.id,
          verificationType: workstationVerification?.verificationType,
        }
      );
    } else {
      await store.dispatch(
        `${WORKSTATION}/setWorkStationSiltVerificationStatus`,
        null
      );
    }
  } catch (error) {
    await store.dispatch(`${WORKSTATION}/setLoadingWorkstation`, false);
    console.log();
  } finally {
    if (resetData) {
      await store.dispatch(`${USER_STORE}/initializeUserState`);
      await store.dispatch(`${USER_STORE}/getAccountStatuses`);
      await store.dispatch(`${PROPERTY_STORE}/fetchProperties`, {});

      await store.dispatch(`${USER_STORE}/setUserCertificates`, user.value?.id);
      await store.dispatch(`${USER_STORE}/setUserInsurances`, user.value?.id);
      await store.dispatch(`${USER_STORE}/getUserSkills`, user.value.id);
      await store.dispatch(`${WORKSTATION}/setLoadingWorkstation`, false);
    }
  }
};

const onClickSwitchUserType = async () => {
  let updatedUser: any;
  // Commented For Now
  try {
    launchInvitedWorkstation.value = true;
    updatedUser = await store.dispatch(`${USER_STORE}/selectAccount`, {
      userId: user.value?.id,
      roleId: RolesEnum.TRADESPERSON,
      email: user.value?.email,
    });
    const authUser = getLocalStorageWithExpiry(AUTH_USER);
    const newUserState = await store.dispatch(
      `${USER_STORE}/getUser`,
      updatedUser?.id
    );
    authUser.userId = newUserState.id;
    authUser.roleId = RolesEnum.TRADESPERSON;
    authUser.aliased = isAliased(newUserState.email);
    // eslint-disable-next-line no-undef
    setLocalStorageWithExpiry(authUser, AUTH_USER, AUTH_SESSION_EXPIRY);
    setTimeout(async () => {
      switchingText.value = "Switching Account...";
      currentSelectedTab.value = tabListItems[0];
      store.commit(`${USER_STORE}/resestStore`);
    }, 1000);
  } catch (error) {
    console.log();
  } finally {
    setTimeout(() => {
      switchingText.value = "Fetching Account Data...";
      currentSelectedTab.value = tabListItems[1];
    }, 2000);
    setTimeout(async () => {
      switchingText.value = "Loading Account...";
      currentSelectedTab.value = tabListItems[2];
      launchInvitedWorkstation.value = false;
      await store.dispatch(`${USER_STORE}/saveUserState`, updatedUser);
      await store.dispatch(`${USER_STORE}/initializeUserState`);
      await router.push({ name: DASHBOARD_ROUTE });
      // Reload the page after navigating to the dashboard
      window.location.reload();
    }, 5000);
  }
};

const formatDate = (dateString: any, format: string) => {
  const date = new Date(dateString);

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const monthsOfYear = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  switch (format) {
    case "fullDate": {
      const day = date.getUTCDate();
      const month = date.getUTCMonth();
      const year = date.getUTCFullYear();
      return `${day} ${monthsOfYear[month]}, ${year}`;
    }
    default: {
      throw new Error("Invalid format type");
    }
  }
};

const processedEmail = (email: any) => {
  if (email.startsWith("iknowa.alias.")) {
    return email.replace("iknowa.alias.", "");
  }
  return email;
};
const onClickGotoRatingPage = () => {
  router.push({ name: VIEW_RATING_ROUTE });
};
const isOpenServicePlanModal = ref(false);
const onClickOpenServicePlanModal = () => {
  isOpenServicePlanModal.value = !isOpenServicePlanModal.value;
};
const onServicePlanAction = (actionType: string) => {
  isOpenServicePlanModal.value = false;
  if (actionType === "workstation") {
    onClickToggleTradesWorkStation();
  }
};

const openPdf = () => {
  window.open(pdfFile, "_blank");
};

const workStationNotificationCount = computed(() => {
  const countObj: any = {};
  userNotifications.value.forEach((notification: any) => {
    countObj[notification?.userWorkstationId] =
      (countObj[notification?.userWorkstationId] || 0) + 1;
  });
  return countObj;
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_InfoIconWhite = _resolveComponent("InfoIconWhite")!
  const _component_CheckIconWhite = _resolveComponent("CheckIconWhite")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("main", {
        class: _normalizeClass(["dashboard-sec tw-pb-16 tw-box-border", { 'md:!tw-pb-16': isUserWorkstationIsDefault.value }])
      }, [
        (
          activeUserWorkstation.value?.user?.userKYCVerificationStatus ===
            _unref(UserVerificationStatusEnum).NOT_ADDED &&
          !activeUserWorkstation.value?.subscription &&
          activeUserWorkstation.value?.subStatus !==
            _unref(UserWorkstationSubStatusEnum).SUCCEEDED &&
          !isUserWorkstationIsDefault.value &&
          !isWorkstationLoading.value
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", { class: "tw-capitalize tw-text-xs tw-flex-wrap tw-text-[#FA4B00]" }, [
                _createTextVNode(" Action Required: Verify your identity to get more Estimates.   "),
                _createElementVNode("span", {
                  class: "tw-underline tw-cursor-pointer tw-text-[#4B4BFF]",
                  onClick: onClickVerifyAccount
                }, "Get Verified")
              ])
            ]))
          : (
          userWorkStationStatus.value === _unref(UserVerificationStatusEnum).NOT_ADDED &&
          activeUserWorkstation.value?.subscription &&
          activeUserWorkstation.value?.subStatus ===
            _unref(UserWorkstationSubStatusEnum).SUCCEEDED &&
          !isUserWorkstationIsDefault.value &&
          !isWorkstationLoading.value
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", { class: "tw-capitalize tw-text-xs tw-flex-wrap tw-text-[#FA4B00]" }, [
                  _createTextVNode(" Action Required: Verify your identity to get more Estimates.   "),
                  _createElementVNode("span", {
                    class: "tw-underline tw-cursor-pointer tw-text-[#4B4BFF]",
                    onClick: onClickVerifyAccount
                  }, "Get Verified")
                ])
              ]))
            : _createCommentVNode("", true),
        (isWorkstationLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(Loader, { show: isWorkstationLoading.value }, null, 8, ["show"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!isUserWorkstationIsDefault.value)
                ? (_openBlock(), _createBlock(Card, {
                    key: 0,
                    class: "!tw-max-h-[unset] tw-w-full !tw-p-5 tw-box-border",
                    withBorder: true,
                    isRoundedxl: true
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("main", _hoisted_7, [
                        (!isUserWorkstationIsDefault.value)
                          ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  (userWorkStationImage.value)
                                    ? (_openBlock(), _createBlock(ProfileThumbnail, {
                                        key: 0,
                                        isRounded: false,
                                        showVerificationIcon: 
                        userWorkStationStatus.value !==
                        _unref(UserVerificationStatusEnum).NOT_ADDED
                      ,
                                        size: "xllg",
                                        src: userWorkStationImage.value,
                                        userKycStatus: userWorkStationStatus.value
                                      }, null, 8, ["showVerificationIcon", "src", "userKycStatus"]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        (userWorkStationStatus.value != 0)
                                          ? (_openBlock(), _createBlock(ChipState, {
                                              key: 0,
                                              bgColor: "#FFF",
                                              hasShadow: true,
                                              class: "tw-absolute tw-top-[-.3rem] tw-right-[-.4rem] tw-z-10 !tw-w-6 !tw-h-6 !tw-px-0 !tw-py-0 !tw-gap-0"
                                            }, {
                                              prefix: _withCtx(() => [
                                                _createVNode(_component_el_tooltip, {
                                                  effect: "light",
                                                  placement: "bottom-start"
                                                }, {
                                                  content: _withCtx(() => [
                                                    _createElementVNode("div", {
                                                      class: "tw-max-w-[200px]",
                                                      innerHTML: toolTipProfile.value
                                                    }, null, 8, _hoisted_12)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    (userWorkStationStatus.value == 2)
                                                      ? (_openBlock(), _createBlock(CheckGreenShield, { key: 0 }))
                                                      : (_openBlock(), _createBlock(InfoIconRed, {
                                                          key: 1,
                                                          color: `#faa500`
                                                        }))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(UserProfileLogo, {
                                          isRounded: false,
                                          desktopFontSizeBig: true
                                        })
                                      ])),
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("h5", _hoisted_14, _toDisplayString(activeUserWorkstation.value?.name), 1),
                                    (
                          activeUserWorkstation.value?.user?.userBusinessDetails
                            ?.residencyAddressLine
                        )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                          _createVNode(Text, {
                                            class: "tw-flex tw-gap-1 !tw-text-[10px] tw-text-[#0C0F4A80]",
                                            textWeight: "400",
                                            textColor: "#0C0F4A",
                                            whiteSpace: "nowrap"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_16,
                                              _createTextVNode(_toDisplayString(getWorkstationPostcode(
                              user.value?.userBusinessDetails?.type
                            )), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(Text, {
                                            class: "!tw-text-[10px] tw-text-[#0C0F4A80]",
                                            textWeight: "400",
                                            textColor: "#0C0F4A",
                                            whiteSpace: "nowrap"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(getWorkstationAddress(
                              user.value?.userBusinessDetails?.type
                            )), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                      onClick: onClickAddress,
                                      class: "tw-flex tw-gap-1 tw-items-center tw-cursor-pointer"
                                    }, [
                                      _createVNode(Text, {
                                        textColor: 
                            activeUserWorkstation.value?.user?.userBusinessDetails
                              ?.residencyAddressLine
                              ? '#5C4EFF'
                              : '#FFA500'
                          ,
                                        variant: "p"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("+")
                                        ]),
                                        _: 1
                                      }, 8, ["textColor"]),
                                      _createVNode(Text, {
                                        textColor: 
                            activeUserWorkstation.value?.user?.userBusinessDetails
                              ?.residencyAddressLine
                              ? '#5C4EFF'
                              : '#FFA500'
                          ,
                                        variant: "span"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(activeUserWorkstation.value?.user?.userBusinessDetails
                              ?.residencyAddressLine
                              ? "Edit Address"
                              : "Add Address"), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["textColor"])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_v_rating, {
                                      "model-value": getAverageOfAllProjectReview.value,
                                      "active-color": "orange",
                                      color: "rgba(12, 15, 74, 0.26)",
                                      "empty-icon": "mdi-star",
                                      readonly: ""
                                    }, null, 8, ["model-value"]),
                                    _createElementVNode("p", _hoisted_19, _toDisplayString(getAverageOfAllProjectReview.value) + " out of 5 ", 1)
                                  ]),
                                  _createVNode(_component_v_btn, {
                                    onClick: onClickGotoRatingPage,
                                    class: "button button-orange",
                                    "append-icon": "mdi-chevron-right"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("view Ratings ")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                (
                      // activeUserWorkstation?.verificationStatus !==
                      //   UserVerificationStatusEnum.VERIFIED &&
                      activeUserWorkstation.value?.subscription &&
                      activeUserWorkstation.value?.subStatus ===
                        _unref(UserWorkstationSubStatusEnum).SUCCEEDED &&
                      userWorkStationStatus.value ===
                        _unref(UserVerificationStatusEnum).NOT_ADDED
                    )
                                  ? (_openBlock(), _createBlock(ProfileVerificationStatusChip, {
                                      key: 0,
                                      class: "tw-hidden rmd:tw-flex",
                                      variant: userWorkstationStatusByWord.value
                                    }, null, 8, ["variant"]))
                                  : _createCommentVNode("", true),
                                (
                      userWorkStationStatus.value ===
                        _unref(UserVerificationStatusEnum).NOT_ADDED &&
                      (!activeUserWorkstation.value?.subscription ||
                        activeUserWorkstation.value?.subStatus !==
                          _unref(UserWorkstationSubStatusEnum).SUCCEEDED)
                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      _hoisted_22,
                                      _createVNode(_component_v_btn, {
                                        class: "upgrade_btn tw-text-[10px] tw-font-bold tw-leading-6 tw-tracking-[1.25px] tw-opacity-100 tw-capitalize tw-p-0",
                                        variant: "plain",
                                        "append-icon": "mdi-chevron-right",
                                        onClick: onClickUpgradePlan
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Upgrade Plan")
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_btn, {
                                  class: "button button-purple w-full tw-mt-auto",
                                  onClick: onClickAddNewProperty
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" add a new property ")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!isUserWorkstationIsDefault.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(PropertiesWidget)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(PreferredContractorsWidget)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(ProjectsOverviewWidget),
                        _createVNode(TeamWidget, {
                          className: "!tw-min-h-[275px]",
                          propMembers: members.value,
                          onGetMembers: getTeamMember
                        }, null, 8, ["propMembers"])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(CalendarEventWidget, { className: "property_calendar" })
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("section", _hoisted_31, [
                    _createVNode(Text, {
                      variant: "h4",
                      class: "tw-mb-4 tw-capitalize rmd:!tw-text-[32px] md:!tw-mb-0 rlg:tw-col-span-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Hello, " + _toDisplayString(user.value?.firstName), 1)
                      ]),
                      _: 1
                    }),
                    (
              !filteredUserAllWorkStation.value.length &&
              !WorkStationInvitation.value.length
            )
                      ? (_openBlock(), _createBlock(Card, {
                          key: 0,
                          class: "manage-ws-card !tw-max-h-[unset] tw-w-full tw-box-border tw-p-6 !tw-px-8 !tw-py-6 md:!tw-px-4 rlg:tw-col-span-2",
                          withBorder: true,
                          bgColor: "rgba(241, 246, 251, 0.50)"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("main", _hoisted_32, [
                              _createElementVNode("section", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                      _createVNode(Text, {
                                        variant: "h3",
                                        class: "md:!tw-text-[20px]",
                                        whiteSpace: "nowrap"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Getting started with iknowa")
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                          _createElementVNode("div", _hoisted_39, [
                                            _createVNode(_component_v_icon, {
                                              icon: "mdi-check-circle",
                                              color: "#264FD5"
                                            }),
                                            _createVNode(Text, {
                                              variant: "span",
                                              textColor: "#264FD5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Completed")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode(Text, {
                                            variant: "h5",
                                            whiteSpace: "nowrap"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Sign up to iknowa")
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(Text, {
                                            variant: "h6",
                                            textWeight: "400"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("You’ve just signed up to"),
                                              _hoisted_40,
                                              _createTextVNode(" iknowa via a link from NWG.")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("img", {
                                          class: "tw-hidden rlg:!tw-flex",
                                          src: 
                              require('@/assets/images/up-next-desktop.svg')
                            ,
                                          alt: ""
                                        }, null, 8, _hoisted_41),
                                        _createElementVNode("img", {
                                          class: "tw-flex rlg:!tw-hidden",
                                          src: require('@/assets/images/up-next-mobile.svg'),
                                          alt: ""
                                        }, null, 8, _hoisted_42)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("img", {
                                        class: "tw-w-[200px]",
                                        src: require('@/assets/images/tp-banner.svg'),
                                        alt: "iknowa banner"
                                      }, null, 8, _hoisted_44),
                                      _createElementVNode("div", _hoisted_45, [
                                        _createVNode(Text, { variant: "h5" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Create your free property workstation")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(Text, {
                                          variant: "h6",
                                          textWeight: "400"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("List properties, raise property service projects, and seamlessly collaborate.")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(Button, {
                                          class: "!tw-w-auto",
                                          label: 
                              filteredUserAllWorkStation.value &&
                              filteredUserAllWorkStation.value.lenght
                                ? 'CREATE A new WORKSTATION'
                                : 'CREATE A free WORKSTATION'
                            ,
                                          variant: "accent",
                                          onClick: onClickToggleTradesWorkStation
                                        }, null, 8, ["label"])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
              (filteredUserAllWorkStation.value &&
                filteredUserAllWorkStation.value.length) ||
              WorkStationInvitation.value.length
            )
                      ? (_openBlock(), _createBlock(Card, {
                          key: 1,
                          withBorder: true,
                          isRoundedxl: true,
                          bgColor: "rgba(241, 246, 251, 0.50)",
                          class: "!tw-max-h-[unset] tw-w-full tw-box-border tw-p-6 md:tw-p-4 rlg:tw-col-span-2"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("main", _hoisted_46, [
                              _createElementVNode("section", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createVNode(Text, { class: "!tw-text-[20px] rlg:!tw-text-[32px]" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Launch a Workstation")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              (
                    filteredUserAllWorkStation.value.length > 0 ||
                    WorkStationInvitation.value.length > 0
                  )
                                ? (_openBlock(), _createElementBlock("section", _hoisted_49, [
                                    (
                      WorkStationInvitation.value && WorkStationInvitation.value.length > 0
                    )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(WorkStationInvitation.value, (member, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "tw-justify-between tw-flex-col ws-items-bg tw-w-full tw-flex tw-items-start tw-p-4 tw-rounded-[6px]",
                                              key: index
                                            }, [
                                              _createElementVNode("div", _hoisted_51, [
                                                _createElementVNode("div", _hoisted_52, _toDisplayString(member?.userRole?.id === 2
                              ? "Property owner"
                              : member?.userRole?.id === 3
                              ? "Sole trader"
                              : ""), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_53, [
                                                (InviteMemberImage.value)
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      class: "ws-profile-logo tw-rounded-full tw-overflow-hidden tw-w-[56px] tw-min-w-[56px] tw-h-[56px] tw-object-cover tw-relative",
                                                      src: InviteMemberImage.value
                                                    }, null, 8, _hoisted_54))
                                                  : (_openBlock(), _createBlock(WorkStationProfileLogo, {
                                                      key: 1,
                                                      class: "tw-rounded-full tw-overflow-hidden tw-w-[56px] tw-min-w-[56px] tw-h-[56px] tw-relative",
                                                      WSName: member?.userWorkstation?.name
                                                    }, null, 8, ["WSName"])),
                                                _createElementVNode("div", _hoisted_55, [
                                                  _createElementVNode("div", _hoisted_56, [
                                                    _createElementVNode("div", _hoisted_57, [
                                                      _createVNode(Text, { variant: "h6" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(member?.userWorkstation?.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createElementVNode("div", _hoisted_58, _toDisplayString(member?.role), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_59, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(parseJSON)(member?.tags), (tag) => {
                                                        return (_openBlock(), _createElementBlock("div", { key: tag }, [
                                                          _createElementVNode("div", _hoisted_60, _toDisplayString(tag), 1)
                                                        ]))
                                                      }), 128))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_61, [
                                                      _createElementVNode("div", _hoisted_62, [
                                                        _createVNode(Text, {
                                                          variant: "span",
                                                          textWeight: "600",
                                                          textColor: "rgba(12, 15, 74, 0.5)"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(member?.user?.email), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      (member?.message)
                                                        ? (_openBlock(), _createBlock(Text, {
                                                            key: 0,
                                                            variant: "span",
                                                            textWeight: "600",
                                                            textColor: "rgba(12, 15, 74, 0.5)"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(member?.message), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true),
                                                      _createVNode(Text, {
                                                        class: "!tw-text-[10px] md:!tw-text-[11px] !tw-leading-none !tw-text-darkBlue/50",
                                                        textWeight: "400"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("Last signed in: " + _toDisplayString(member?.lastLoginAt
                                    ? formatDate(
                                        member?.lastLoginAt,
                                        "fullDate"
                                      )
                                    : "Not Signed"), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ])
                                                  ]),
                                                  (
                              member?.invitationStatus ===
                              _unref(MemberInvitationStatusEnum).PENDING
                            )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                                        _createVNode(_component_v_btn, {
                                                          class: "tw-px-[8px] tw-py-[6px] md:tw-py-[10px] tw-box-border tw-rounded-[6px] tw-text-[12px] tw-flex tw-gap-3 tw-items-center tw-justify-center tw-bg-[#F45454] tw-text-white tw-font-bold tw-capitalize !tw-h-[auto] tw-leading-none tw-shadow-none",
                                                          onClick: ($event: any) => (onClickRejectWSInvitation(member?.id))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_InfoIconWhite),
                                                            _hoisted_64
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]),
                                                        _createVNode(_component_v_btn, {
                                                          loading: 
                                acceptInvitaionLoader.value &&
                                acceptInvitationWorkstationId.value === member?.token
                              ,
                                                          class: "tw-px-[8px] tw-py-[6px] md:tw-py-[10px] tw-box-border tw-rounded-[6px] tw-text-[12px] tw-flex tw-gap-3 tw-items-center tw-justify-center tw-bg-[#1FB27A] tw-text-white tw-font-bold tw-capitalize !tw-h-[auto] tw-leading-none tw-shadow-none",
                                                          onClick: ($event: any) => (onClickAcceptWSInvitation(member?.token))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_CheckIconWhite),
                                                            _hoisted_65
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["loading", "onClick"])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (
                              member?.invitationStatus ===
                              _unref(MemberInvitationStatusEnum).ACCEPTED
                            )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                                        _createVNode(_component_v_btn, {
                                                          class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#4B4BFF] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5",
                                                          onClick: ($event: any) => (
                                onWorkStationClick(member?.userWorkstation?.id)
                              )
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(" launch "),
                                                            _createVNode(LunchIcon, { class: "tw-ml-2" })
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]),
                                                        _createVNode(_component_v_btn, {
                                                          class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F45454] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5",
                                                          onClick: ($event: any) => (onClickRejectWSInvitation(member?.id))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(" Delete "),
                                                            _createVNode(TrashIcon, {
                                                              class: "tw-ml-2",
                                                              fill: "#FFF",
                                                              fillOpacity: "1"
                                                            })
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]),
                                                        _createElementVNode("div", _hoisted_67, [
                                                          _createVNode(DeleteActionChip, {
                                                            onClick: ($event: any) => (onClickRejectWSInvitation(member?.id))
                                                          }, null, 8, ["onClick"])
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_68, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUserAllWorkStation.value, (member, index) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                                          (index < numberOfWsShowed.value)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                class: "tw-justify-between tw-flex-col ws-items-bg tw-w-full tw-flex tw-items-start tw-p-4 tw-rounded-[6px]",
                                                key: index
                                              }, [
                                                _createElementVNode("div", _hoisted_69, [
                                                  _createElementVNode("div", _hoisted_70, _toDisplayString(member?.userRole?.id === 2
                                ? "Property owner"
                                : member?.userRole?.id === 3
                                ? "Sole trader"
                                : ""), 1),
                                                  _createElementVNode("div", _hoisted_71, [
                                                    _createVNode(NotificationIcon),
                                                    _createElementVNode("span", _hoisted_72, _toDisplayString(workStationNotificationCount.value[member?.id] || 0), 1),
                                                    _createVNode(_component_v_btn, {
                                                      class: "tw-px-4 md:tw-px-2 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#4B4BFF] tw-text-white tw-font-medium tw-capitalize tw-text-sm md:tw-text-[11px] !tw-h-[auto] tw-leading-5",
                                                      onClick: ($event: any) => (onWorkStationClick(member?.id))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" launch "),
                                                        _createVNode(LunchIcon, { class: "tw-ml-2 md:tw-max-w-[9px]" })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]),
                                                    (member?.isInvited)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          loading: 
                                deleteInvitedWorkstationLoader.value &&
                                deleteInvitedWorkstationId.value === member?.memberId
                              ,
                                                          class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F45454] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5 md:tw-hidden",
                                                          onClick: ($event: any) => (
                                onClickRejectWSInvitation(member?.memberId)
                              )
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(" Delete "),
                                                            _createVNode(TrashIcon, {
                                                              class: "tw-ml-2",
                                                              fill: "#FFF",
                                                              fillOpacity: "1"
                                                            })
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["loading", "onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_73, [
                                                  (member?.imageUrl)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: member?.imageUrl,
                                                        class: "ws-profile-logo tw-rounded-full tw-overflow-hidden tw-w-[56px] tw-min-w-[56px] tw-h-[56px] tw-object-cover tw-relative"
                                                      }, null, 8, _hoisted_74))
                                                    : (_openBlock(), _createBlock(WorkStationProfileLogo, {
                                                        key: 1,
                                                        class: "tw-rounded-full tw-overflow-hidden tw-w-[56px] tw-min-w-[56px] tw-h-[56px] tw-relative",
                                                        WSName: member?.name
                                                      }, null, 8, ["WSName"])),
                                                  _createElementVNode("div", _hoisted_75, [
                                                    _createElementVNode("div", _hoisted_76, [
                                                      _createElementVNode("div", _hoisted_77, [
                                                        _createVNode(Text, { variant: "h6" }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(member?.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        (member?.role)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                                              _createVNode(Text, {
                                                                variant: "p",
                                                                textWeight: "400"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(member?.role), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                                              _createVNode(Text, {
                                                                variant: "p",
                                                                textWeight: "400"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Admin")
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]))
                                                      ]),
                                                      (member?.tags)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(parseJSON)(member?.tags), (tag) => {
                                                              return (_openBlock(), _createElementBlock("div", {
                                                                class: "tw-flex",
                                                                key: tag
                                                              }, [
                                                                _createElementVNode("div", _hoisted_81, _toDisplayString(tag), 1)
                                                              ]))
                                                            }), 128))
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("div", _hoisted_82, [
                                                        _hoisted_83,
                                                        (member?.message)
                                                          ? (_openBlock(), _createBlock(Text, {
                                                              key: 0,
                                                              variant: "span",
                                                              textWeight: "600",
                                                              textColor: "rgba(12, 15, 74, 0.5)"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(member?.message), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : _createCommentVNode("", true),
                                                        _createVNode(Text, {
                                                          class: "!tw-text-[10px] md:!tw-text-[11px] !tw-leading-none !tw-text-darkBlue/50",
                                                          textWeight: "400"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("Last signed in: " + _toDisplayString(member?.lastLoginAt
                                      ? formatDate(
                                          member?.lastLoginAt,
                                          "fullDate"
                                        )
                                      : "Not Signed"), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_84, [
                                                      _createVNode(NotificationIcon),
                                                      _createElementVNode("span", _hoisted_85, _toDisplayString(workStationNotificationCount.value[member?.id] || 0), 1),
                                                      _createVNode(_component_v_btn, {
                                                        class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#4B4BFF] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5",
                                                        onClick: ($event: any) => (onWorkStationClick(member?.id))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" launch "),
                                                          _createVNode(LunchIcon, { class: "tw-ml-2" })
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"]),
                                                      (member?.isInvited)
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 0,
                                                            loading: 
                                  deleteInvitedWorkstationLoader.value &&
                                  deleteInvitedWorkstationId.value ===
                                    member?.memberId
                                ,
                                                            class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F45454] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5",
                                                            onClick: ($event: any) => (
                                  onClickRejectWSInvitation(member?.memberId)
                                )
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" Delete "),
                                                              _createVNode(TrashIcon, {
                                                                class: "tw-ml-2",
                                                                fill: "#FFF",
                                                                fillOpacity: "1"
                                                              })
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["loading", "onClick"]))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_86, [
                                                  (member?.isInvited)
                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 0,
                                                        loading: 
                              deleteInvitedWorkstationLoader.value &&
                              deleteInvitedWorkstationId.value === member?.memberId
                            ,
                                                        class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F45454] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5",
                                                        onClick: ($event: any) => (onClickRejectWSInvitation(member?.memberId))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Delete "),
                                                          _createVNode(TrashIcon, {
                                                            class: "tw-ml-2",
                                                            fill: "#FFF",
                                                            fillOpacity: "1"
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["loading", "onClick"]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 256))
                                    ]),
                                    _createElementVNode("div", _hoisted_87, [
                                      (filteredUserAllWorkStation.value?.length > 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                            (!isShowAllws.value)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: "tw-flex tw-items-center tw-gap-2 tw-cursor-pointer",
                                                  onClick: toggleShowWs
                                                }, [
                                                  _createVNode(Text, {
                                                    textWeight: "600",
                                                    variant: "h6",
                                                    textColor: "rgba(12, 15, 74, 0.5)"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("See " + _toDisplayString(`${filteredUserAllWorkStation.value?.length - 3}`) + " more workstation", 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_icon, {
                                                    icon: "mdi-chevron-down",
                                                    color: "rgba(12, 15, 74, 0.5)"
                                                  })
                                                ]))
                                              : _createCommentVNode("", true),
                                            (isShowAllws.value)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: "tw-flex tw-items-center tw-gap-2 tw-cursor-pointer",
                                                  onClick: toggleShowWs
                                                }, [
                                                  _createVNode(Text, {
                                                    textWeight: "600",
                                                    variant: "p",
                                                    textColor: "rgba(12, 15, 74, 0.5)"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("See less workstation")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_icon, {
                                                    icon: "mdi-chevron-up",
                                                    color: "rgba(12, 15, 74, 0.5)"
                                                  })
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode(Button, {
                                        class: "!tw-w-auto !tw-p-0 tw-box-border !tw-text-[#FFA500]",
                                        variant: "custom",
                                        onClick: onClickToggleTradesWorkStation,
                                        label: "Create a new workstation",
                                        activeBgColor: "transparent",
                                        width: "auto",
                                        isCapitalize: true,
                                        fontWeight: 700
                                      }, {
                                        postfix: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            icon: "mdi-chevron-right",
                                            color: "#FFA500"
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("section", _hoisted_89, [
                                    _createElementVNode("div", _hoisted_90, [
                                      _createVNode(Text, {
                                        variant: "h3",
                                        class: "md:!tw-text-[20px]",
                                        whiteSpace: "nowrap"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Getting started with iknowa")
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_91, [
                                        _createElementVNode("div", _hoisted_92, [
                                          _createElementVNode("div", _hoisted_93, [
                                            _createVNode(_component_v_icon, {
                                              icon: "mdi-check-circle",
                                              color: "#264FD5"
                                            }),
                                            _createVNode(Text, {
                                              variant: "span",
                                              textColor: "#264FD5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Completed")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode(Text, {
                                            variant: "h5",
                                            whiteSpace: "nowrap"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Sign up to iknowa")
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(Text, {
                                            variant: "h6",
                                            textWeight: "400"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("You’ve just signed up to"),
                                              _hoisted_94,
                                              _createTextVNode(" iknowa via a link from NWG.")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("img", {
                                          class: "tw-hidden rlg:!tw-flex",
                                          src: require('@/assets/images/up-next-desktop.svg'),
                                          alt: ""
                                        }, null, 8, _hoisted_95),
                                        _createElementVNode("img", {
                                          class: "tw-flex rlg:!tw-hidden",
                                          src: require('@/assets/images/up-next-mobile.svg'),
                                          alt: ""
                                        }, null, 8, _hoisted_96)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_97, [
                                      _createElementVNode("img", {
                                        class: "tw-w-[200px]",
                                        src: require('@/assets/images/tp-banner.svg'),
                                        alt: "iknowa banner"
                                      }, null, 8, _hoisted_98),
                                      _createElementVNode("div", _hoisted_99, [
                                        _createVNode(Text, { variant: "h5" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Create your free property workstation")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(Text, {
                                          variant: "h6",
                                          textWeight: "400"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Unlock access to subsidised upskilling courses, estimate new job opportunities, and seamlessly collaborate.")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(Button, {
                                          class: "!tw-w-auto",
                                          label: 
                          filteredUserAllWorkStation.value &&
                          filteredUserAllWorkStation.value.lenght
                            ? 'CREATE A new WORKSTATION'
                            : 'CREATE A Free WORKSTATION'
                        ,
                                          variant: "accent",
                                          onClick: onClickToggleTradesWorkStation
                                        }, null, 8, ["label"])
                                      ])
                                    ])
                                  ]))
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(Card, {
                      class: "!tw-max-h-[unset] tw-w-full tw-box-border tw-p-6 md:tw-p-4",
                      withBorder: true,
                      isRoundedxl: true
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("section", _hoisted_100, [
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, [
                              _createVNode(Text, { class: "!tw-text-[22px]" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Manage emails")
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_103, [
                              _createElementVNode("div", _hoisted_104, [
                                _createElementVNode("div", _hoisted_105, [
                                  _createElementVNode("div", _hoisted_106, [
                                    _createVNode(Text, {
                                      variant: "xsmall",
                                      textWeight: "700",
                                      textColor: "#4F55F0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Primary")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode(Text, {
                                    variant: "p",
                                    textWeight: "400"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(userEmail.value), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(manageEmailList.value, (email) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-border-0 tw-pb-2 !tw-gap-[.3rem] s540:!tw-flex-col",
                                  key: email.id
                                }, [
                                  _createElementVNode("div", _hoisted_107, [
                                    (email?.invitationStatus === 'accepted')
                                      ? (_openBlock(), _createBlock(ApproveChip, { key: 0 }))
                                      : _createCommentVNode("", true),
                                    (email?.invitationStatus === 'pending')
                                      ? (_openBlock(), _createBlock(PendingChip, { key: 1 }))
                                      : _createCommentVNode("", true),
                                    _createVNode(Text, {
                                      variant: "p",
                                      textWeight: "400"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(email?.aliasEmail), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createElementVNode("div", _hoisted_108, [
                                    _createVNode(DeleteActionChip, {
                                      onClick: ($event: any) => (onClickDeleteEmail(email))
                                    }, null, 8, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_109, [
                            _createVNode(Button, {
                              class: "!tw-w-auto !tw-p-0 tw-box-border !tw-text-[#FFA500]",
                              variant: "custom",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleAddEmailModal(true))),
                              label: "Add Email Address",
                              activeBgColor: "transparent",
                              width: "auto",
                              isCapitalize: true,
                              fontWeight: 700
                            }, {
                              postfix: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-chevron-right",
                                  color: "#FFA500"
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(Card, {
                      class: "!tw-max-h-[unset] tw-w-full tw-box-border tw-p-6 md:tw-p-4",
                      withBorder: true,
                      isRoundedxl: true
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("section", _hoisted_110, [
                          _createElementVNode("img", {
                            class: "!tw-w-[124px]",
                            src: require('@/assets/images/iknowa-benefits.png')
                          }, null, 8, _hoisted_111),
                          _createElementVNode("section", _hoisted_112, [
                            _createElementVNode("div", _hoisted_113, [
                              _createElementVNode("div", _hoisted_114, [
                                _createVNode(Text, { class: "!tw-text-[22px]" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Learn more about iknowa")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(Text, {
                                  variant: "h6",
                                  textWeight: "400"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Explore everything that the iknowa can do.")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _hoisted_115
                            ]),
                            _createElementVNode("div", _hoisted_116, [
                              _createVNode(Button, {
                                class: "!tw-w-auto !tw-p-0 tw-box-border !tw-text-[#FFA500]",
                                variant: "custom",
                                onClick: onClickBenefitsButton,
                                label: "Explore iknowa benefits",
                                activeBgColor: "transparent",
                                width: "auto",
                                isCapitalize: true,
                                fontWeight: 700
                              }, {
                                postfix: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: "mdi-chevron-right",
                                    color: "#FFA500"
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(Card, {
                      class: "!tw-max-h-[unset] tw-w-full tw-box-border tw-p-6 md:tw-p-4",
                      withBorder: true,
                      isRoundedxl: true
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("section", _hoisted_117, [
                          _createElementVNode("img", {
                            class: "!tw-w-[124px]",
                            src: require('@/assets/images/upcoming-events.svg')
                          }, null, 8, _hoisted_118),
                          _createElementVNode("section", _hoisted_119, [
                            _createElementVNode("div", _hoisted_120, [
                              _createElementVNode("div", _hoisted_121, [
                                _createVNode(Text, { class: "!tw-text-[22px]" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Stay tuned for more events in 2025")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(Text, {
                                  variant: "h6",
                                  textWeight: "400"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Join us and connect with peers, gain insights from experts, and take steps towards advancing your career in the trade industry.")
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
            ]))
      ], 2),
      (isShowAddEmailModal.value)
        ? (_openBlock(), _createBlock(AddEmailModal, {
            key: 0,
            onOnClose: _cache[1] || (_cache[1] = ($event: any) => (toggleAddEmailModal($event))),
            onOnClickAdd: onClickAddEmail
          }))
        : _createCommentVNode("", true),
      (isShowAddEmailConformModal.value)
        ? (_openBlock(), _createBlock(EmailConformModal, {
            key: 1,
            modalType: emailConfirmModalType.value,
            manageEmail: manageEmail.value,
            onOnClose: toggleAddEmailConfirmModal
          }, null, 8, ["modalType", "manageEmail"]))
        : _createCommentVNode("", true),
      (isShowPropertyOwnerWorkStationModal.value)
        ? (_openBlock(), _createBlock(PropertyOwnerWorkStationModal, {
            key: 2,
            onOnClickCloseTab: onClickClosePOWorkstationModal
          }))
        : _createCommentVNode("", true),
      (isShowPropertyOwnerSubscriptionModal.value)
        ? (_openBlock(), _createBlock(PropertyOwnerSubscriptionModal, {
            key: 3,
            SelectWorkstationType: true,
            onCloseSelectWorkstationTypeModal: onClickCloseButton
          }))
        : _createCommentVNode("", true)
    ]),
    (openedModel.value === modelName.VERIFYMODAL)
      ? (_openBlock(), _createBlock(WorkstationVerificationModal, {
          key: 0,
          onClickCloseTab: onClickCloseModel
        }))
      : _createCommentVNode("", true),
    (isShowUpgradePremiumModal.value)
      ? (_openBlock(), _createBlock(PropertyOwnerSubscriptionModal, {
          key: 1,
          onCloseSubscriptionModal: closeUpgradePremiumModal,
          onCloseSelectWorkstationTypeModal: closeUpgradePremiumModal
        }))
      : _createCommentVNode("", true),
    (openedModel.value === modelName.ADDRESSMODAL)
      ? (_openBlock(), _createBlock(AddAddressModal, {
          key: 2,
          onOnCloseSuccess: onClickCloseModel,
          onOnClose: onClickCloseModel
        }))
      : _createCommentVNode("", true),
    (isOpenServicePlanModal.value)
      ? (_openBlock(), _createBlock(PropertyServicePlanModal, {
          key: 3,
          onOnClose: onClickOpenServicePlanModal,
          onOnAction: onServicePlanAction
        }))
      : _createCommentVNode("", true),
    (isShowPropertyOwnerBenefitsModal.value)
      ? (_openBlock(), _createBlock(PropertyOwnerBenefitsModal, {
          key: 4,
          onOnClickClosePreviewModalButton: toggleBenefitModal
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      width: "350px",
      modelValue: launchInvitedWorkstation.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((launchInvitedWorkstation).value = $event)),
      class: "modal_box action-modal",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_122, [
          _createElementVNode("main", _hoisted_123, [
            _createElementVNode("div", null, [
              _hoisted_124,
              _createElementVNode("p", _hoisted_125, _toDisplayString(switchingText.value), 1),
              _createVNode(_component_v_stepper, {
                class: "onboard-stepper",
                modelValue: currentSelectedTab.value.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentSelectedTab.value.name) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabListItems, (step, index) => {
                        return _createVNode(_component_v_stepper_item, {
                          class: "onboard-stepper__item",
                          key: index,
                          value: step.name
                        }, null, 8, ["value"])
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (isShowIDCheckModal.value)
      ? (_openBlock(), _createBlock(CommonDialog, {
          key: 5,
          className: ['property_owner_id_Check_modal'],
          onClickBackButton: onClickCloseIDCheckButton,
          HeaderTittle: HeaderTittle.value,
          title: "We need to verify your identity",
          width: "650px",
          height: "auto"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_126, [
              _hoisted_127,
              _createElementVNode("div", _hoisted_128, [
                _hoisted_129,
                (isShowNextButton.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "button button-orange w-full"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Next")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  loading: isLoading.value,
                  class: "button button-purple-border",
                  onClick: onClickKycTypeIdVerification,
                  width: "100%"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Start ID verification ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["HeaderTittle"]))
      : _createCommentVNode("", true),
    (isShowSuccessModel.value)
      ? (_openBlock(), _createBlock(PropertySuccessModal, {
          key: 6,
          onClose: toggleSuccessModel
        }))
      : _createCommentVNode("", true),
    (isShowClientAgreementModal.value)
      ? (_openBlock(), _createBlock(ClientFlowServiceAgreementModal, {
          key: 7,
          onOnClose: onToggleClientAgreementModal,
          onOnConfirm: onToggleClientAgreementModal
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})